export default __webpack_public_path__ + "static/media/icon_schedule_normal.ba31c051.svg";